import { render, staticRenderFns } from "./ResourceProjectCalendar.vue?vue&type=template&id=6a63e2e7&scoped=true&"
import script from "./ResourceProjectCalendar.vue?vue&type=script&lang=js&"
export * from "./ResourceProjectCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ResourceProjectCalendar.vue?vue&type=style&index=0&id=6a63e2e7&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a63e2e7",
  null
  
)

export default component.exports